import { DetailsInfoDisplay } from '@/property-details/components/details-info-modules/details-info-display';
import first from 'lodash/first';
import { useMemo } from 'react';
import { renewalAppHasStatuses } from '../../utils/license-utils';
import { LicenseHeaderTitle } from './license-header-title';
import { TLicenseHeaderProps } from './types';
import { createColumnDataSet } from './utils';

export function LicenseHeader(props: TLicenseHeaderProps) {
  const {
    isLicenseApplication,
    license,
    licenseTitleText,
    leftColumnConfig,
    rightColumnConfig,
  } = props;

  const renewalsAvailable = useMemo(
    /**
     * At the moment, it seems like there will only be one renewal
     *  application at a time, so we can always pick the first
     *  element in the array
     */
    () => renewalAppHasStatuses(first(license?.renewals)),
    [license]
  );

  return (
    <DetailsInfoDisplay
      title={
        <LicenseHeaderTitle
          isLicenseApplication={isLicenseApplication}
          renewalsAvailable={renewalsAvailable}
          status={license?.status}
          text={licenseTitleText}
        />
      }
      left={createColumnDataSet(leftColumnConfig)}
      right={createColumnDataSet(rightColumnConfig)}
    />
  );
}
